const returnColor = (color:string):string => color &&!color.startsWith("#") ? `#${color}` : color;

export default returnColor;
